import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

// Keep query results local to the mounted consumer; no unbounded global cache.
// Split Firestore `in` queries and release every listener on cleanup.
export function subscribeIn(collectionName, field, values, onData, onError = console.error) {
  const ids = [...new Set(values.filter(value => typeof value === 'string' && value))].sort();
  if (!ids.length) { onData([]); return () => {}; }
  let active = true;
  const batches = new Map();
  const stops = [];
  for (let i = 0; i < ids.length; i += 30) {
    const batch = i;
    stops.push(onSnapshot(query(collection(db, collectionName), where(field, 'in', ids.slice(i, i + 30))), snapshot => {
      if (!active) return;
      batches.set(batch, snapshot.docs.map(d => ({ ...d.data(), key: d.id, uid: d.id })));
      if (batches.size === Math.ceil(ids.length / 30)) onData([...batches.values()].flat());
    }, error => { if (active) onError(error); }));
  }
  return () => { active = false; stops.forEach(stop => stop()); batches.clear(); };
}
